/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TrackResult } from './TrackResult';
import {
    TrackResultFromJSON,
    TrackResultFromJSONTyped,
    TrackResultToJSON,
} from './TrackResult';

/**
 * 
 * @export
 * @interface TrackGet200Response
 */
export interface TrackGet200Response {
    /**
     * 
     * @type {Array<TrackResult>}
     * @memberof TrackGet200Response
     */
    records?: Array<TrackResult>;
}

/**
 * Check if a given object implements the TrackGet200Response interface.
 */
export function instanceOfTrackGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TrackGet200ResponseFromJSON(json: any): TrackGet200Response {
    return TrackGet200ResponseFromJSONTyped(json, false);
}

export function TrackGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(TrackResultFromJSON)),
    };
}

export function TrackGet200ResponseToJSON(value?: TrackGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(TrackResultToJSON)),
    };
}

